import type Experiments from '@wix/wix-experiments'
import type {
  RouterConfig,
  EditorSDK,
} from '@wix/wix-data-client-common-standalone'
import { values } from '@wix/wix-data-client-common-standalone'

export const shouldUseSeoV2RouteConfig = async ({
  experimentsManager,
  editorSdkProxy,
}: {
  experimentsManager: Experiments
  editorSdkProxy: EditorSDK
}): Promise<boolean> => {
  if (experimentsManager.enabled('specs.wixDataClient.SEOSettings')) {
    return true
  }
  const routers = await editorSdkProxy.routers.getAll<RouterConfig>()
  const hasSeoV2Routes = routers.some(router =>
    values(router.config.patterns).some(pattern => pattern.config?.seoV2),
  )
  if (hasSeoV2Routes) {
    return true
  }
  const hasValidRoutes = routers.some(router =>
    values(router.config.patterns).some(
      pattern =>
        pattern.config &&
        router.pages.some(page => page.pageRoles[0] === pattern.pageRole),
    ),
  )
  return !hasValidRoutes
}
